define(['skinExports/generated/skinExports'], function (skins) {
    'use strict';
    return skins;
});
